module.exports = __webpack_public_path__ + "assets_app/img/key_9.34cf27e7.svg";